import { Injector } from "@dojo/framework/core/Injector";
import { Store } from "redux";
import { ApiContext } from "../widgets/injectors/ApiContext";

/**
 * Redux injector payload format
 */
export interface IReduxInjectorPayload<S, O> {
    store: Store<S>;
    extraOptions?: O;
    apiContext: ApiContext;
}

/**
 * This module is constructed out of
 * https://raw.githubusercontent.com/dojo/interop/master/src/redux/ReduxInjector.ts
 * as there is no corresponding build available. When dojo/interop build is
 * available with these changes, consume the original module than this
 */

/**
 * Injector for redux store
 */
export class ReduxInjector<S = any, O = any> extends Injector<IReduxInjectorPayload<S, O>> {
	/**
	 * Sets the store and attaches the injectors invalidate to the redux
	 * stores bind.
	 *
	 * @param store The store for the injector
	 * @param extraOptions Additional options returned alongside the store with `getProperties`
	 */
	constructor(store: Store<S>, apiContext: ApiContext, extraOptions?: O) {
		super({ store, apiContext, extraOptions });
	}

	/**
	 * Stores cannot be set on instances of `ReduxInjector`.
	 */
	public set(): never {
		throw new TypeError("Cannot perform .set() on ReduxInjector");
	}

	setInvalidator(invalidator: () => void): void {
		super.setInvalidator(invalidator);
		this.get().store.subscribe(() => {
			invalidator();
		});
	}
}

export default ReduxInjector;
